var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"color":"info","target":"_blank","href":"https://github.com/acampagnaro/api-tentacle/releases/"}},[_vm._v(" Download Tentacle "),_c('v-divider',{staticClass:"mx-6",attrs:{"vertical":""}}),_c('v-icon',[_vm._v("mdi-cloud-download-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }